var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('appbase',{ref:"appBase",on:{"route":_vm.route}},[(_vm.faqIMBtnEnable)?_c('faqimbtn',{attrs:{"slot":"footer"},slot:"footer"}):_vm._e(),(_vm.agentNoticeVisible)?_c('agentNotice',{attrs:{"slot":"footer"},slot:"footer"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }